module.exports = __webpack_public_path__ + "static/media/mega-menu-bg.5bead904.png";